import { render, staticRenderFns } from "./fileUploader.vue?vue&type=template&id=01453ecd&scoped=true"
import script from "./fileUploader.vue?vue&type=script&lang=js"
export * from "./fileUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01453ecd",
  null
  
)

export default component.exports